const state = {
  showToast: false,
  type: '',
  message: '',
};

const actions = {
  showToast({ commit }, { type, message }) {
    commit('toastShow', { type, message });

    setTimeout(() => {
      commit('toastClear');
    }, 5000);
  },

  hideToast({ commit }) {
    commit('toastClear');
  },
};

const mutations = {
  toastShow(state, { type, message }) {
    state.showToast = true;
    state.type = type;
    state.message = message;
  },

  toastClear(state) {
    state.showToast = false;
    state.type = '';
    state.message = '';
  },
};

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations,
};
